import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d05b06b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title-contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "box-contents" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text box-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "售后服务")
], -1))
const _hoisted_7 = { class: "cart-contents-info" }
const _hoisted_8 = { class: "list" }
const _hoisted_9 = { style: {"font-size":"16px","color":"#333333"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"question-list\" data-v-d05b06b0><div class=\"question-list-c\" data-v-d05b06b0><p class=\"question-title\" data-v-d05b06b0>常见问题</p><p class=\"question-title-s\" data-v-d05b06b0>1. 如何申请退款？</p><p class=\"question-info\" data-v-d05b06b0> 根据您订单状态不同，申请方式也是不一样的。待发货订单申请后可快速退款。已签收订单需与客服协商一致并退款。 </p><p class=\"question-title-s\" data-v-d05b06b0>2. 如何换货？</p><p class=\"question-info\" data-v-d05b06b0> 您可以申请退货退款，再重新下单购买您所需要的商品 </p><p class=\"question-title-s\" data-v-d05b06b0> 3. 申请退款后，显示退款成功，钱退到哪里？ </p><p class=\"question-info\" data-v-d05b06b0> 当订单的退款状态显示【退款成功】时，钱款会退回原支付渠道。 </p></div></div>", 1)

import { ref, reactive, getCurrentInstance, onMounted } from "vue"
import HtmlFooter from "@/components/HtmlFooter.vue"
import HomeHead from "@/components/HomeHead.vue"
import CurrentAddress from "@/components/common/CurrentAddress.vue"
import { useRoute, useRouter } from "vue-router"
import { orderApi } from "@/service/api"
import { sjyAlert } from "@/utils/alert"
import { showPrice } from "@/utils/public"
import GoodsRealItem from "@/components/order/GoodsRealItem.vue"
import GoodsPrice from "@/components/order/GoodsOrderPrice.vue"
import GoodsPart from "@/components/order/GoodsPart.vue"

interface orderDataType {
  errno: number
  datas: any
  errmsg: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PostSaleList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const params = useRoute()
let orderId = parseInt(params.params.orderid as string)
let router = useRouter()

/**
 * 申请售后
 * @param orderId
 */
let postSale = (goodsId: number, type: number) => {
  if (type == 1) {
    router.push({
      name: "postsalestatus",
      params: {
        orderid: orderData.datas.id,
        goodsid: goodsId,
        orderno: orderData.datas.oid,
      },
    })
  } else {
    router.push({
      name: "postsale",
      params: {
        orderid: orderData.datas.id,
        goodsid: goodsId,
        orderno: orderData.datas.oid,
      },
    })
  }
}

/**
 * 申请售后
 * @param orderId
 */
let showPostSale = (orderId: number) => {
  router.push({ name: "postsalestatus", params: { orderid: orderId } })
}

const orderData: orderDataType = reactive({
  errno: 0,
  errmsg: "",
  datas: [],
})
let handleSelectionChange = () => { }

/**
 * 获取订单信息
 */
let getOrderInfo = () => {
  orderApi.getOrderInfo(orderId).then((res: any) => {
    if (res.errno == 0) {
      orderData.datas = res.datas
      console.log(orderData.datas)
    } else {
      sjyAlert(res.errmsg, "error")
    }
  })
}

onMounted(() => {
  getOrderInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HomeHead),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 售后服务")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_table, {
            data: orderData.datas.list,
            style: {"width":"100%"},
            "header-row-class-name": "title-name",
            onSelectionChange: _unref(handleSelectionChange)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "date",
                label: "商品信息",
                width: "561"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(GoodsRealItem, {
                    data: scope.row
                  }, null, 8, ["data"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "商品价格（含税）",
                width: "258"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(GoodsPrice, {
                    data: scope.row,
                    orderType: orderData.datas.order_type
                  }, null, 8, ["data", "orderType"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "数量",
                width: "207"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(GoodsPart, {
                    cartId: parseInt(scope.row.id),
                    numbers: parseInt(scope.row.numbers)
                  }, null, 8, ["cartId", "numbers"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "小计(含税)",
                width: "207"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon iconfont", {
                  'icon-a-Group14379': orderData.datas.order_type == 0,
                  'icon-renminbi': orderData.datas.order_type == 1,
                  'icon-renminbi-price': orderData.datas.order_type == 1,
                }])
                    }, null, 2),
                    _createTextVNode(_toDisplayString(_unref(showPrice)(
    orderData.datas.order_type == 0
      ? scope.row.money
      : scope.row.money * scope.row.numbers,
    orderData.datas.order_type
  )), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "售后服务",
                width: "207"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    style: {"font-size":"16px","color":"#333333","cursor":"pointer"},
                    onClick: ($event: any) => (_unref(postSale)(scope.row.gid, scope.row.sales))
                  }, _toDisplayString(scope.row.sales == 1 ? "查看售后" : "申请售后"), 9, _hoisted_10)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSelectionChange"])
        ])
      ]),
      _hoisted_11
    ]),
    _createVNode(HtmlFooter)
  ]))
}
}

})